export const GetReferralInvoicesFlagActions= {
	
	GetReferralInvoicesFlag_GET :{
		NEW:"GetReferralInvoicesFlag_GET_NEW",
		SUCCESS:"GetReferralInvoicesFlag_GET_SUCCESS",
		FAILED:"GetReferralInvoicesFlag_GET_FALIURE",
		LOADING:"GetReferralInvoicesFlag_GET_LOADING",
		UPDATE:"DisableGetReferralInvoicesFlag_Update_SUCCESS",
	},
	
}


export const GetReferralInvoicesFlagStatus ={

	GetReferralInvoicesFlag_GET :{
		NEW:"GetReferralInvoicesFlag_GET_NEW",
		SUCCESS:"GetReferralInvoicesFlag_GET_SUCCESS",
		FAILED:"GetReferralInvoicesFlag_GET_FALIURE",
		LOADING:"GetReferralInvoicesFlag_GET_LOADING",
	}

}
